import { getSdk } from "./sdkService";
import { getBillingInfo } from "./billingService";

/**
 * Uses the SDK to perform a login and in case of being successful, the app store is notified that the user is logged in
 * so that the app UI is updated accordingly.
 * @param {string} username The user name of the account found in local storage
 * @param {string} password The password of the account found in local storage
 * @returns {Promise}
 */
export async function generatePin() {
  try {
    const sdk = await getSdk();
    const pinResponse = await sdk.userManager.generatePin();
    return pinResponse;
  } catch (error) {
    throw error;
  }
}

/**
 * Uses the SDK to perform a login and in case of being successful, the app store is notified that the user is logged in
 * so that the app UI is updated accordingly.
 * @param {string} username The user name of the account found in local storage
 * @param {string} password The password of the account found in local storage
 * @returns {Promise}
 */
export async function loginPin(data) {
  try {
    const sdk = await getSdk();
    const pinResponse = await sdk.userManager.loginPin(data);
    return pinResponse;
  } catch (error) {
    throw error;
  }
}
/**
 * Uses the SDK to create a web token with uid and spx-token and in case of being successful, the app store is notified that the user is logged in
 * so that the app UI is updated accordingly.
 * @param {string} username The user name of the account found in local storage
 * @param {string} password The password of the account found in local storage
 * @returns {Promise}
 */
export async function generateToken(data) {
  try {
    const sdk = await getSdk();
   // const tokenResponse = await sdk.userManager.generateToken(data);
   const tokenResponse = await sdk.userManager.login(data);
   getBillingInfo(true);
  return tokenResponse;
  } catch (error) {
    throw error;
  }
}